import { FiTrendingUp } from "react-icons/fi";
import { MdOutlineLocalOffer, MdOutlineStarRate, MdOutlineRecommend } from "react-icons/md";
import { MARKET } from "./marketplaceRoutes";

export const MARKET_HOME_SECTIONS = {
  trending: {
    title: "TRENDING",
    link: MARKET.DEALS_TRENDING,
    Icon: FiTrendingUp,
    productsKey: "trendingProducts",
    errorMessage: "Could not load trending deals",
    emptyMessage: "No trending deals available",
  },
  todayDeals: {
    title: "TODAY DEALS",
    link: MARKET.DEALS_TODAY,
    Icon: MdOutlineLocalOffer,
    productsKey: "todaysDealProducts",
    errorMessage: "Could not load today deals",
    emptyMessage: "No today deals available",
  },
  topSelling: {
    title: "TOP SELLING ITEMS",
    link: MARKET.DEALS_TOP_SELLING,
    Icon: MdOutlineStarRate,
    productsKey: "hotDealProducts",
    errorMessage: "Could not load top selling items",
    emptyMessage: "No top selling items available",
  },
  recommended: {
    title: "RECOMMENDED",
    link: MARKET.DEALS_RECOMMENDED,
    Icon: MdOutlineRecommend,
    productsKey: "products",
    errorMessage: "Could not load recommended products",
    emptyMessage: "No recommended products available",
  },
};
